import React, { FC, ReactNode, useEffect, useState } from 'react';
import { WeeklyRosterContext } from './context';
import { RosterType, StaffType } from 'models/kitchen-roster.model';
import { apiService } from 'utils/api';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import moment from 'moment';

const WeeklyRosterProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [addRosterFormData, setAddRosterFormData] = useState<RosterType[]>([
    { department: '', afternoon: [], morning: [], night: [] }
  ]);

  const [staff, setStaff] = useState<StaffType[]>([]);
  const [year, setYear] = useState(moment().year());
  const [department, setDepartment] = useState({ name: '', value: '' });

  const getStaff = async () => {
    try {
      const res = await apiService.get('kitchen/staff', {
        baseUrl: process.env.REACT_APP_KITCHEN_API_URL,
        params: {
          size: 1000
        }
      });
      if (res.data.data.results) setStaff(res.data.data.results);
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error.response.data.message} />);
    }
  };

  useEffect(() => {
    getStaff();
  }, []);

  return (
    <WeeklyRosterContext.Provider
      value={{
        addRosterFormData,
        setAddRosterFormData,
        staff,
        year,
        setYear,
        department,
        setDepartment
      }}>
      {children}
    </WeeklyRosterContext.Provider>
  );
};

export default WeeklyRosterProvider;
